"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const i18n_js_1 = __importDefault(require("i18n-js"));
const DownloadApp_1 = __importDefault(require("../Other/DownloadApp"));
const DeadEnd = styled_components_1.default.div `
  .disclaimer {
    padding: 8px 16px;
    margin: 10px 0 0 0;
  }
`;
const KidsClubDeadEnd = () => (react_1.default.createElement(DeadEnd, null,
    react_1.default.createElement("p", { className: "disclaimer" }, i18n_js_1.default.t("download_required_for_kids_club")),
    react_1.default.createElement(DownloadApp_1.default, null)));
exports.default = KidsClubDeadEnd;
